<template>
  <div>
    <div class="modal-form-coluna">
      <div>
        <h3>CNAES <span>*</span></h3>
        <div>
          <BotaoPadrao
            arredondadoDireita
            class="botao-cnaes"
            :nome="!mostraCnaes ? 'Exibir lista de CNAEs' : 'Ocultar lista de cnaes'"
            icone="list"
            :click="exibeCnaes"
            cor="azul"
            tooltip="Selecione um ou mais CNAEs para esta empresa"
          />
        </div>
        <div v-if="mostraCnaes">
          <CenarioInput
            tipo="texto"
            placeholder="Filtro de CNAEs"
            :model="filtroCnae"
            @update:model="update => (filtroCnae = update)"
          />
          <div class="cnae-lista-container">
            <div
              @click="handleClickCnae(item)"
              :class="['cnae-lista', { selecionado: form.cnae.find(f => f.value == item.value) }]"
              v-for="(item, index) in cnaesFiltradas"
              :key="index"
            >
              {{ item.label }}
            </div>
          </div>
        </div>

        <div class="selecionadas-wrapper">
          <h3>CNAES SELECIONADOS:</h3>
          <div
            ref="selecionados"
            :class="[
              'cnaes-selecionados-container',
              { requerido: Object.keys(camposRequeridos).includes('cnae') && exibeValidacao }
            ]"
          >
            <div
              v-if="form.cnae.length > 0"
              class="cnaes-selecionados"
              v-for="(item, index) in form.cnae"
              :key="index"
            >
              <div>
                {{ item.label }}
              </div>
              <div class="remover-cnae-container" @click="removerCnae(item)">
                <font-awesome-icon
                  class="remover-cnae"
                  icon="trash-alt"
                  v-b-tooltip.hover.window.left
                  title="Remover CNAE"
                />
              </div>
            </div>
            <div  v-b-tooltip.hover.window title="Clique no botão acima para adicionar CNAEs" :class="['cnaes-selecionados']" v-if="form.cnae.length == 0">
              Nenhuma CNAE selecionada
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "ModalEmpresaSegundaLinha",
  components: {
    BotaoPadrao,
    CenarioInput
  },
  props: {
    calculaForm: Function,
    inserirCnae: Function,
    removerCnae: Function,
    form: Object,
    camposRequeridos: Object,
    exibeValidacao: Boolean,
    limpaModalEmpresa: Boolean,
    listaCnae: Array
  },

  data() {
    return {
      mostraCnaes: false,
      filtroCnae: ""
    };
  },
  watch: {
    limpaModalEmpresa() {
      this.mostraCnaes = false;
    }
  },
  computed: {
    cnaesFiltradas() {
      if (!this.listaCnae) {
        return [];
      }
      if (this.filtroCnae == "") {
        return this.listaCnae;
      }
      return this.listaCnae.filter(f => f.label.includes(this.filtroCnae));
    }
  },
  methods: {
    exibeCnaes() {
      this.mostraCnaes = !this.mostraCnaes;
    },
    handleClickCnae(item) {
      if (this.form.cnae.find(f => f.value == item.value)) {
        this.removerCnae(item);
        this.$nextTick(() => {
          this.$refs.selecionados.scrollTo(0, 1000000);
        });
      } else {
        this.inserirCnae({ label: item.label, value: item.value });
        this.$nextTick(() => {
          this.$refs.selecionados.scrollTo(0, 1000000);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}

.cenario-cnpj {
  display: flex;
}
.modal-form-coluna {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 15px;
}
.cnae-lista-container {
  max-height: 110px;
  border: 1px solid #d4d4d4;
  overflow: auto;
}
.cnae-lista {
  padding: 2px 10px;
  cursor: pointer;
  border-bottom: 1px solid #d4d4d4;
  &:last-child {
    border-bottom: none;
  }
}
.selecionado {
  background: #d1d2d171;
  // color: var(--branco);
  // &:hover {
  //   background: #0099da79 !important;
  // }
}
.cnaes-selecionados-container {
  border: 1px solid #d4d4d4;
  max-height: 110px;
  overflow-y: scroll;
}
.cnaes-selecionados {
  display: flex;
  justify-content: space-between;
  padding: 2px 10px;
  border-bottom: 1px solid #d4d4d4;
  &:last-child {
    border-bottom: none;
  }
}
.requerido {
  transition: border 1s ease;
  border: 1px solid red;
}

.selecionadas-wrapper {
  margin-top: 10px;
}
.remover-cnae {
  cursor: pointer;

  font-size: 15px;
  color: var(--vermelho3);
}
.botao-cnaes {
  margin-bottom: 10px;
}
.cnaes-linha-botao {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.remover-cnae-container {
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
</style>
